import React,{useState} from "react";
import TextField from '@material-ui/core/TextField';
import {  getMyProfile, updateMyProfile, changePassword} from "../../crud/auth.crud";
import { Formik,Field } from "formik";

import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";


import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from "react-intl";

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';


                  

class MyProfile extends React.Component 
{
	
	state = {
    users:[],
    tab1:'active',
    tab2: '',
    tab3: '',
   	tab4: '',
   	loading:false,
   	status:false,
   	statusMessage:'',
   	statusColor:'alert-success',
   	isSubmitting: false,
  	}

  	//const {intl} = props;



constructor(props)
{
  super(props);
    this.state = {
      users:[],
	  tab1: 'active',
	  tab2: '',
	  tab3: '',
	  tab4: '',
	  status:false,
   	  statusMessage:'',
   	  statusColor:'alert-success'
    };


  
}





 

componentDidMount()
  {
    
    getMyProfile().then(response => response.data)
    .then((data) => {
      this.setState({ users: data })
      //console.log(this.state.users)
     })
  }

	render() {
		
		const userData = this.state.users[0];
		const { classes } = this.props;
		const loading = this.state.loading;
		const status = this.state.status;
		const statusMessage = this.state.statusMessage;
		const statusColor = this.state.statusColor;
    	return (
      		<>
      			{this.state.status && (
									                        <div role="alert" className={"alert "+this.state.statusColor}>
									                          <div className="alert-text">{this.state.statusMessage}</div>
									                        </div>
									                      )}
      			<div className="kt-portlet kt-portlet--tabs">
					<div className="kt-portlet__head">
											<div className="kt-portlet__head-toolbar">
												<ul className="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand" role="tablist">
													<li className="nav-item">
														<a className={"nav-link " + this.state.tab1} data-toggle="tab" href="#kt_user_edit_tab_1" role="tab" onClick={() => this.setState({tab1:'active', tab2: '',tab3:'',tab4:''}) }>
															 Profile
														</a>
													</li>
													{/*<li className="nav-item">
														<a className={"nav-link " + this.state.tab2} data-toggle="tab" href="#kt_user_edit_tab_2" role="tab" onClick={() => this.setState({tab1:'', tab2: 'active',tab3:'',tab4:''}) }>
															 Account
														</a>
													</li>*/}
													<li className="nav-item">
														<a className={"nav-link " + this.state.tab3} data-toggle="tab" href="#kt_user_edit_tab_3" role="tab" onClick={() => this.setState({tab1:'', tab2: '',tab3:'active',tab4:''}) }>
															 Change Password
														</a>
													</li>
													{/*<li className="nav-item">
														<a className={"nav-link " + this.state.tab4} data-toggle="tab" href="#kt_user_edit_tab_4" role="tab" onClick={() => this.setState({tab1:'', tab2: '',tab3:'',tab4:'active'}) }>
															 Settings
														</a>
													</li>*/}
												</ul>
											</div>
					</div>
		      		<div className="kt-portlet__body">
						
										<div className="tab-content">
											<div className={"tab-pane " + this.state.tab1} id="kt_user_edit_tab_1" role="tabpanel">
												<div className="kt-form kt-form--label-right" style={{display: this.state.tab1 ? 'block' : 'none'}}>
													{this.state.users.map((udata,index) => (
													<Formik
									                  initialValues={{
									                    firstName: udata.firstName,
									                    lastName: udata.lastName,
									                    email: udata.email,
									                    mobile: udata.mobile,
									                    city:udata.city,
									                    address:udata.address,
									                    state:udata.state,
									                    country:udata.country,
									                    pincode:udata.pincode
									                    
									                  }}
									                  validate={values => {
									                    const errors = {};
									                   

									                    return errors;
									                  }}
									                onSubmit={(values, { setStatus, setSubmitting }) => {

									                    this.setState({loading:true,isSubmitting:true});
									                    updateMyProfile(
									                      values.firstName,
									                      values.lastName,
									                      values.email,
									                      values.mobile,
									                      values.city,
									                      values.address,
									                      values.state,
									                      values.country,
									                      values.pincode
									                      
									                    )
									                      .then(resp => {
									                        //props.register(accessToken);

									                       this.setState({status:true,statusColor:'alert-success',statusMessage:'Updated successfully',loading:false,isSubmitting:false});
									                       window.scrollTo(0,0);
									                      })
									                      .catch(() => {
									                        this.setState({status:true,statusColor:'alert-danger',statusMessage:'Error Occured',loading:false,isSubmitting:false});
									                      });
									                  }}
									                >
									                {({
									                    values,
									                    status,
									                    errors,
									                    touched,
									                    handleChange,
									                    handleBlur,
									                    handleSubmit,
									                    isSubmitting,
									                   
									                  }) => (
									                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
									                      

													
													<div className="kt-form__body">

														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Customer Info:</h3>
																	</div>
																</div>
																
																
																
																							      									
							      									{/*<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Avatar</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-avatar kt-avatar--outline kt-avatar--circle-" id="kt_user_edit_avatar">
																			<div className="kt-avatar__holder" ></div>
																			<label className="kt-avatar__upload" data-toggle="kt-tooltip" title="" data-original-title="Change avatar">
																				<i className="fa fa-pen"></i>
																				<input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" />
																			</label>
																			<span className="kt-avatar__cancel" data-toggle="kt-tooltip" title="" data-original-title="Cancel avatar">
																				<i className="fa fa-times"></i>
																			</span>
																		</div>
																	</div>
																</div>*/}
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">First Name</label>
																	<div className="col-lg-9 col-xl-6">
																		
																		<Field
																		  type="text"
																		  value ={values.firstName}
																		  name="firstName"
																		  className={`form-control ${
																		    touched.firstName && errors.firstName ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Last Name</label>
																	<div className="col-lg-9 col-xl-6">
																		
																		<Field
																		  type="text"
																		  value ={values.lastName}
																		  name="lastName"
																		  className={`form-control ${
																		    touched.lastName && errors.lastName ? "is-invalid" : ""
																		  }`}
																		/>
																		
																	</div>
																</div>
																
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Contact Phone</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="input-group">
																			<div className="input-group-prepend"><span className="input-group-text"><i className="la la-phone"></i></span></div>
																			
																			<Field
																		  type="text"
																		  value ={values.mobile}
																		  name="mobile"
																		  className={`form-control ${
																		    touched.mobile && errors.mobile ? "is-invalid" : ""
																		  }`}
																		/>
																		</div>
																		<span className="form-text text-muted">We'll never share your email with anyone else.</span>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Email Address</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="input-group">
																			<div className="input-group-prepend"><span className="input-group-text"><i className="la la-at"></i></span></div>
																			<Field
																		  type="text"
																		  value ={values.email}
																		  disabled={true}
																		  name="email"
																		  className={`form-control ${
																		    touched.email && errors.email ? "is-invalid" : ""
																		  }`}
																		/>
																		</div>
																	</div>
																</div>

							      							

																																
																
																

															</div>
														</div>
														<div className="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg"></div>
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Address:</h3>
																	</div>
																</div>
																
																	
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Address line 1</label>
																	<div className="col-lg-9 col-xl-6">
																		
																		<Field
																		  type="text"
																		  value ={values.address}
																		  name="address"
																		  className={`form-control ${
																		    touched.address && errors.address ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Pincode</label>
																	<div className="col-lg-9 col-xl-6">
																		<Field
																		  type="text"
																		  value ={values.pincode}
																		  name="pincode"
																		  className={`form-control ${
																		    touched.pincode && errors.pincode ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">City</label>
																	<div className="col-lg-9 col-xl-6">
																		<Field
																		  type="text"
																		  value ={values.city}
																		  name="city"
																		  className={`form-control ${
																		    touched.city && errors.city ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>
																
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">State</label>
																	<div className="col-lg-9 col-xl-6">
																		<Field
																		  type="text"
																		  value ={values.state}
																		  name="state"
																		  className={`form-control ${
																		    touched.state && errors.state ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>

																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Country</label>
																	<div className="col-lg-9 col-xl-6">
																		<Field
																		  type="text"
																		  value ={values.country}
																		  name="country"
																		  className={`form-control ${
																		    touched.country && errors.country ? "is-invalid" : ""
																		  }`}
																		/>
																	</div>
																</div>
																

							      									


																																
																
																

															</div>
														</div>
													</div>
												
													 <div className="kt-login__actions">
                       

								                        <button
								                          disabled={this.state.isSubmitting}
								                         type="submit"
								                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
								                              {
								                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
								                              }
								                            )}`}
								                          >
								                           Update
								                        </button>
								                      </div>
								                    </form>
								                  )}
								                </Formik>
								                	))}	

												</div>
											</div>
											<div className={"tab-pane " + this.state.tab2} id="kt_user_edit_tab_2" role="tabpanel">
												<div className="kt-form kt-form--label-right">
													<div className="kt-form__body">
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Account:</h3>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Username</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-spinner kt-spinner--sm kt-spinner--success kt-spinner--right kt-spinner--input">
																			<input className="form-control" type="text" value="nick84"/>
																		</div>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Email Address</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="input-group">
																			<div className="input-group-prepend"><span className="input-group-text"><i className="la la-at"></i></span></div>
																			<input type="text" className="form-control" value="nick.watson@loop.com" placeholder="Email" aria-describedby="basic-addon1"/>
																		</div>
																		<span className="form-text text-muted">Email will not be publicly displayed. <a href="#" className="kt-link">Learn more</a>.</span>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Language</label>
																	<div className="col-lg-9 col-xl-6">
																		<select className="form-control">
																			<option>Select Language...</option>
																			<option value="id">Bahasa Indonesia - Indonesian</option>
																			<option value="msa">Bahasa Melayu - Malay</option>
																			<option value="ca">Català - Catalan</option>
																			<option value="cs">Čeština - Czech</option>
																			<option value="da">Dansk - Danish</option>
																			<option value="de">Deutsch - German</option>
																			<option value="en" selected="">English</option>
																			<option value="en-gb">English UK - British English</option>
																			<option value="es">Español - Spanish</option>
																			<option value="eu">Euskara - Basque (beta)</option>
																			<option value="fil">Filipino</option>
																			<option value="fr">Français - French</option>
																			<option value="ga">Gaeilge - Irish (beta)</option>
																			<option value="gl">Galego - Galician (beta)</option>
																			<option value="hr">Hrvatski - Croatian</option>
																			<option value="it">Italiano - Italian</option>
																			<option value="hu">Magyar - Hungarian</option>
																			<option value="nl">Nederlands - Dutch</option>
																			<option value="no">Norsk - Norwegian</option>
																			<option value="pl">Polski - Polish</option>
																			<option value="pt">Português - Portuguese</option>
																			<option value="ro">Română - Romanian</option>
																			<option value="sk">Slovenčina - Slovak</option>
																			<option value="fi">Suomi - Finnish</option>
																			<option value="sv">Svenska - Swedish</option>
																			<option value="vi">Tiếng Việt - Vietnamese</option>
																			<option value="tr">Türkçe - Turkish</option>
																			<option value="el">Ελληνικά - Greek</option>
																			<option value="bg">Български език - Bulgarian</option>
																			<option value="ru">Русский - Russian</option>
																			<option value="sr">Српски - Serbian</option>
																			<option value="uk">Українська мова - Ukrainian</option>
																			<option value="he">עִבְרִית - Hebrew</option>
																			<option value="ur">اردو - Urdu (beta)</option>
																			<option value="ar">العربية - Arabic</option>
																			<option value="fa">فارسی - Persian</option>
																			<option value="mr">मराठी - Marathi</option>
																			<option value="hi">हिन्दी - Hindi</option>
																			<option value="bn">বাংলা - Bangla</option>
																			<option value="gu">ગુજરાતી - Gujarati</option>
																			<option value="ta">தமிழ் - Tamil</option>
																			<option value="kn">ಕನ್ನಡ - Kannada</option>
																			<option value="th">ภาษาไทย - Thai</option>
																			<option value="ko">한국어 - Korean</option>
																			<option value="ja">日本語 - Japanese</option>
																			<option value="zh-cn">简体中文 - Simplified Chinese</option>
																			<option value="zh-tw">繁體中文 - Traditional Chinese</option>
																		</select>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Time Zone</label>
																	<div className="col-lg-9 col-xl-6">
																		<select className="form-control">
																			<option data-offset="-39600" value="International Date Line West">(GMT-11:00) International Date Line West</option>
																			<option data-offset="-39600" value="Midway Island">(GMT-11:00) Midway Island</option>
																			<option data-offset="-39600" value="Samoa">(GMT-11:00) Samoa</option>
																			<option data-offset="-36000" value="Hawaii">(GMT-10:00) Hawaii</option>
																			<option data-offset="-28800" value="Alaska">(GMT-08:00) Alaska</option>
																			<option data-offset="-25200" value="Pacific Time (US &amp; Canada)">(GMT-07:00) Pacific Time (US &amp; Canada)</option>
																			<option data-offset="-25200" value="Tijuana">(GMT-07:00) Tijuana</option>
																			<option data-offset="-25200" value="Arizona">(GMT-07:00) Arizona</option>
																			<option data-offset="-21600" value="Mountain Time (US &amp; Canada)">(GMT-06:00) Mountain Time (US &amp; Canada)</option>
																			<option data-offset="-21600" value="Chihuahua">(GMT-06:00) Chihuahua</option>
																			<option data-offset="-21600" value="Mazatlan">(GMT-06:00) Mazatlan</option>
																			<option data-offset="-21600" value="Saskatchewan">(GMT-06:00) Saskatchewan</option>
																			<option data-offset="-21600" value="Central America">(GMT-06:00) Central America</option>
																			<option data-offset="-18000" value="Central Time (US &amp; Canada)">(GMT-05:00) Central Time (US &amp; Canada)</option>
																			<option data-offset="-18000" value="Guadalajara">(GMT-05:00) Guadalajara</option>
																			<option data-offset="-18000" value="Mexico City">(GMT-05:00) Mexico City</option>
																			<option data-offset="-18000" value="Monterrey">(GMT-05:00) Monterrey</option>
																			<option data-offset="-18000" value="Bogota">(GMT-05:00) Bogota</option>
																			<option data-offset="-18000" value="Lima">(GMT-05:00) Lima</option>
																			<option data-offset="-18000" value="Quito">(GMT-05:00) Quito</option>
																			<option data-offset="-14400" value="Eastern Time (US &amp; Canada)">(GMT-04:00) Eastern Time (US &amp; Canada)</option>
																			<option data-offset="-14400" value="Indiana (East)">(GMT-04:00) Indiana (East)</option>
																			<option data-offset="-14400" value="Caracas">(GMT-04:00) Caracas</option>
																			<option data-offset="-14400" value="La Paz">(GMT-04:00) La Paz</option>
																			<option data-offset="-14400" value="Georgetown">(GMT-04:00) Georgetown</option>
																			<option data-offset="-10800" value="Atlantic Time (Canada)">(GMT-03:00) Atlantic Time (Canada)</option>
																			<option data-offset="-10800" value="Santiago">(GMT-03:00) Santiago</option>
																			<option data-offset="-10800" value="Brasilia">(GMT-03:00) Brasilia</option>
																			<option data-offset="-10800" value="Buenos Aires">(GMT-03:00) Buenos Aires</option>
																			<option data-offset="-9000" value="Newfoundland">(GMT-02:30) Newfoundland</option>
																			<option data-offset="-7200" value="Greenland">(GMT-02:00) Greenland</option>
																			<option data-offset="-7200" value="Mid-Atlantic">(GMT-02:00) Mid-Atlantic</option>
																			<option data-offset="-3600" value="Cape Verde Is.">(GMT-01:00) Cape Verde Is.</option>
																			<option data-offset="0" value="Azores">(GMT) Azores</option>
																			<option data-offset="0" value="Monrovia">(GMT) Monrovia</option>
																			<option data-offset="0" value="UTC">(GMT) UTC</option>
																			<option data-offset="3600" value="Dublin">(GMT+01:00) Dublin</option>
																			<option data-offset="3600" value="Edinburgh">(GMT+01:00) Edinburgh</option>
																			<option data-offset="3600" value="Lisbon">(GMT+01:00) Lisbon</option>
																			<option data-offset="3600" value="London">(GMT+01:00) London</option>
																			<option data-offset="3600" value="Casablanca">(GMT+01:00) Casablanca</option>
																			<option data-offset="3600" value="West Central Africa">(GMT+01:00) West Central Africa</option>
																			<option data-offset="7200" value="Belgrade">(GMT+02:00) Belgrade</option>
																			<option data-offset="7200" value="Bratislava">(GMT+02:00) Bratislava</option>
																			<option data-offset="7200" value="Budapest">(GMT+02:00) Budapest</option>
																			<option data-offset="7200" value="Ljubljana">(GMT+02:00) Ljubljana</option>
																			<option data-offset="7200" value="Prague">(GMT+02:00) Prague</option>
																			<option data-offset="7200" value="Sarajevo">(GMT+02:00) Sarajevo</option>
																			<option data-offset="7200" value="Skopje">(GMT+02:00) Skopje</option>
																			<option data-offset="7200" value="Warsaw">(GMT+02:00) Warsaw</option>
																			<option data-offset="7200" value="Zagreb">(GMT+02:00) Zagreb</option>
																			<option data-offset="7200" value="Brussels">(GMT+02:00) Brussels</option>
																			<option data-offset="7200" value="Copenhagen">(GMT+02:00) Copenhagen</option>
																			<option data-offset="7200" value="Madrid">(GMT+02:00) Madrid</option>
																			<option data-offset="7200" value="Paris">(GMT+02:00) Paris</option>
																			<option data-offset="7200" value="Amsterdam">(GMT+02:00) Amsterdam</option>
																			<option data-offset="7200" value="Berlin">(GMT+02:00) Berlin</option>
																			<option data-offset="7200" value="Bern">(GMT+02:00) Bern</option>
																			<option data-offset="7200" value="Rome">(GMT+02:00) Rome</option>
																			<option data-offset="7200" value="Stockholm">(GMT+02:00) Stockholm</option>
																			<option data-offset="7200" value="Vienna">(GMT+02:00) Vienna</option>
																			<option data-offset="7200" value="Cairo">(GMT+02:00) Cairo</option>
																			<option data-offset="7200" value="Harare">(GMT+02:00) Harare</option>
																			<option data-offset="7200" value="Pretoria">(GMT+02:00) Pretoria</option>
																			<option data-offset="10800" value="Bucharest">(GMT+03:00) Bucharest</option>
																			<option data-offset="10800" value="Helsinki">(GMT+03:00) Helsinki</option>
																			<option data-offset="10800" value="Kiev">(GMT+03:00) Kiev</option>
																			<option data-offset="10800" value="Kyiv">(GMT+03:00) Kyiv</option>
																			<option data-offset="10800" value="Riga">(GMT+03:00) Riga</option>
																			<option data-offset="10800" value="Sofia">(GMT+03:00) Sofia</option>
																			<option data-offset="10800" value="Tallinn">(GMT+03:00) Tallinn</option>
																			<option data-offset="10800" value="Vilnius">(GMT+03:00) Vilnius</option>
																			<option data-offset="10800" value="Athens">(GMT+03:00) Athens</option>
																			<option data-offset="10800" value="Istanbul">(GMT+03:00) Istanbul</option>
																			<option data-offset="10800" value="Minsk">(GMT+03:00) Minsk</option>
																			<option data-offset="10800" value="Jerusalem">(GMT+03:00) Jerusalem</option>
																			<option data-offset="10800" value="Moscow">(GMT+03:00) Moscow</option>
																			<option data-offset="10800" value="St. Petersburg">(GMT+03:00) St. Petersburg</option>
																			<option data-offset="10800" value="Volgograd">(GMT+03:00) Volgograd</option>
																			<option data-offset="10800" value="Kuwait">(GMT+03:00) Kuwait</option>
																			<option data-offset="10800" value="Riyadh">(GMT+03:00) Riyadh</option>
																			<option data-offset="10800" value="Nairobi">(GMT+03:00) Nairobi</option>
																			<option data-offset="10800" value="Baghdad">(GMT+03:00) Baghdad</option>
																			<option data-offset="14400" value="Abu Dhabi">(GMT+04:00) Abu Dhabi</option>
																			<option data-offset="14400" value="Muscat">(GMT+04:00) Muscat</option>
																			<option data-offset="14400" value="Baku">(GMT+04:00) Baku</option>
																			<option data-offset="14400" value="Tbilisi">(GMT+04:00) Tbilisi</option>
																			<option data-offset="14400" value="Yerevan">(GMT+04:00) Yerevan</option>
																			<option data-offset="16200" value="Tehran">(GMT+04:30) Tehran</option>
																			<option data-offset="16200" value="Kabul">(GMT+04:30) Kabul</option>
																			<option data-offset="18000" value="Ekaterinburg">(GMT+05:00) Ekaterinburg</option>
																			<option data-offset="18000" value="Islamabad">(GMT+05:00) Islamabad</option>
																			<option data-offset="18000" value="Karachi">(GMT+05:00) Karachi</option>
																			<option data-offset="18000" value="Tashkent">(GMT+05:00) Tashkent</option>
																			<option data-offset="19800" value="Chennai">(GMT+05:30) Chennai</option>
																			<option data-offset="19800" value="Kolkata">(GMT+05:30) Kolkata</option>
																			<option data-offset="19800" value="Mumbai">(GMT+05:30) Mumbai</option>
																			<option data-offset="19800" value="New Delhi">(GMT+05:30) New Delhi</option>
																			<option data-offset="19800" value="Sri Jayawardenepura">(GMT+05:30) Sri Jayawardenepura</option>
																			<option data-offset="20700" value="Kathmandu">(GMT+05:45) Kathmandu</option>
																			<option data-offset="21600" value="Astana">(GMT+06:00) Astana</option>
																			<option data-offset="21600" value="Dhaka">(GMT+06:00) Dhaka</option>
																			<option data-offset="21600" value="Almaty">(GMT+06:00) Almaty</option>
																			<option data-offset="21600" value="Urumqi">(GMT+06:00) Urumqi</option>
																			<option data-offset="23400" value="Rangoon">(GMT+06:30) Rangoon</option>
																			<option data-offset="25200" value="Novosibirsk">(GMT+07:00) Novosibirsk</option>
																			<option data-offset="25200" value="Bangkok">(GMT+07:00) Bangkok</option>
																			<option data-offset="25200" value="Hanoi">(GMT+07:00) Hanoi</option>
																			<option data-offset="25200" value="Jakarta">(GMT+07:00) Jakarta</option>
																			<option data-offset="25200" value="Krasnoyarsk">(GMT+07:00) Krasnoyarsk</option>
																			<option data-offset="28800" value="Beijing">(GMT+08:00) Beijing</option>
																			<option data-offset="28800" value="Chongqing">(GMT+08:00) Chongqing</option>
																			<option data-offset="28800" value="Hong Kong">(GMT+08:00) Hong Kong</option>
																			<option data-offset="28800" value="Kuala Lumpur">(GMT+08:00) Kuala Lumpur</option>
																			<option data-offset="28800" value="Singapore">(GMT+08:00) Singapore</option>
																			<option data-offset="28800" value="Taipei">(GMT+08:00) Taipei</option>
																			<option data-offset="28800" value="Perth">(GMT+08:00) Perth</option>
																			<option data-offset="28800" value="Irkutsk">(GMT+08:00) Irkutsk</option>
																			<option data-offset="28800" value="Ulaan Bataar">(GMT+08:00) Ulaan Bataar</option>
																			<option data-offset="32400" value="Seoul">(GMT+09:00) Seoul</option>
																			<option data-offset="32400" value="Osaka">(GMT+09:00) Osaka</option>
																			<option data-offset="32400" value="Sapporo">(GMT+09:00) Sapporo</option>
																			<option data-offset="32400" value="Tokyo">(GMT+09:00) Tokyo</option>
																			<option data-offset="32400" value="Yakutsk">(GMT+09:00) Yakutsk</option>
																			<option data-offset="34200" value="Darwin">(GMT+09:30) Darwin</option>
																			<option data-offset="34200" value="Adelaide">(GMT+09:30) Adelaide</option>
																			<option data-offset="36000" value="Canberra">(GMT+10:00) Canberra</option>
																			<option data-offset="36000" value="Melbourne">(GMT+10:00) Melbourne</option>
																			<option data-offset="36000" value="Sydney">(GMT+10:00) Sydney</option>
																			<option data-offset="36000" value="Brisbane">(GMT+10:00) Brisbane</option>
																			<option data-offset="36000" value="Hobart">(GMT+10:00) Hobart</option>
																			<option data-offset="36000" value="Vladivostok">(GMT+10:00) Vladivostok</option>
																			<option data-offset="36000" value="Guam">(GMT+10:00) Guam</option>
																			<option data-offset="36000" value="Port Moresby">(GMT+10:00) Port Moresby</option>
																			<option data-offset="36000" value="Solomon Is.">(GMT+10:00) Solomon Is.</option>
																			<option data-offset="39600" value="Magadan">(GMT+11:00) Magadan</option>
																			<option data-offset="39600" value="New Caledonia">(GMT+11:00) New Caledonia</option>
																			<option data-offset="43200" value="Fiji">(GMT+12:00) Fiji</option>
																			<option data-offset="43200" value="Kamchatka">(GMT+12:00) Kamchatka</option>
																			<option data-offset="43200" value="Marshall Is.">(GMT+12:00) Marshall Is.</option>
																			<option data-offset="43200" value="Auckland">(GMT+12:00) Auckland</option>
																			<option data-offset="43200" value="Wellington">(GMT+12:00) Wellington</option>
																			<option data-offset="46800" value="Nuku'alofa">(GMT+13:00) Nuku'alofa</option>
																		</select>
																	</div>
																</div>
																<div className="form-group form-group-last row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Communication</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-checkbox-inline">
																			<label className="kt-checkbox">
																				<input type="checkbox" checked=""/> Email
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox" checked=""/> SMS
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox"/> Phone
																				<span></span>
																			</label>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg"></div>
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Security:</h3>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Login verification</label>
																	<div className="col-lg-9 col-xl-6">
																		<button type="button" className="btn btn-label-brand btn-bold btn-sm kt-margin-t-5 kt-margin-b-5">Setup login verification</button>
																		<span className="form-text text-muted">
																			After you log in, you will be asked for additional information to confirm your identity and protect your account from being compromised.
																			<a href="www.smartch.com" className="kt-link">Learn more</a>.
																		</span>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Password reset verification</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-checkbox-single">
																			<label className="kt-checkbox">
																				<input type="checkbox"/> Require personal information to reset your password.
																				<span></span>
																			</label>
																		</div>
																		<span className="form-text text-muted">
																			For extra security, this requires you to confirm your email or phone number when you reset your password.
																			<a href="www.smartch.com" className="kt-link">Learn more</a>.
																		</span>
																	</div>
																</div>
																<div className="form-group row kt-margin-t-10 kt-margin-b-10">
																	<label className="col-xl-3 col-lg-3 col-form-label"></label>
																	<div className="col-lg-9 col-xl-6">
																		<button type="button" className="btn btn-label-danger btn-bold btn-sm kt-margin-t-5 kt-margin-b-5">Deactivate your account ?</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className={"tab-pane " + this.state.tab3} id="kt_user_edit_tab_3" role="tabpanel">
											 <div className="kt-form kt-form--label-right" style={{display: this.state.tab3 ? 'block' : 'none'}}>
											 <Formik
													                  initialValues={{
													                    password: "",
													                    verifyPassword: "",
													                  }}
													                  validate={values => {
													                    const errors = {};
													                   
													                   if (!values.password) {
													                      errors.password = this.props.intl.formatMessage({
													                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
													                      });
													                    }

													                    if (!values.verifyPassword) {
													                      errors.verifyPassword = this.props.intl.formatMessage({
													                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
													                      });
													                    }

																		if (values.verifyPassword!==values.password) {
																			errors.verifyPassword = this.props.intl.formatMessage({
																			  id: "AUTH.VALIDATION.REQUIRED_FIELD"
																			});
																		  }

													                   

													                    return errors;
													                  }}
													                onSubmit={(values, { setStatus, setSubmitting }) => {

													                    this.setState({loading:true,isSubmitting:true});
													                    changePassword(
													                      values.password,
													                      values.verifyPassword,
													                    )
													                      .then(resp => {
													                        //props.register(accessToken);

													                       this.setState({status:true,statusColor:'alert-success',statusMessage:'Updated successfully',loading:false,isSubmitting:false});
													                       window.scrollTo(0,0);
													                      })
													                      .catch(() => {
													                        this.setState({status:true,statusColor:'alert-danger',statusMessage:'Error Occured',loading:false,isSubmitting:false});
													                      });
													                  }}
													                >
													                {({
													                    values,
													                    status,
													                    errors,
													                    touched,
													                    handleChange,
													                    handleBlur,
													                    handleSubmit,
													                    isSubmitting,
													                   
													                  }) => (
													                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
													                      

												
													<div className="kt-form__body">
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																{/*<div className="alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40" role="alert">
																	<div className="alert-icon"><i className="fa fa-exclamation-triangle"></i></div>
																	<div className="alert-text">Configure user passwords to expire periodically. <br/>Users will need warning that their passwords are going to expire, or they might inadvertently get locked out of the system!</div>
																	<div className="alert-close">
																		<button type="button" className="close" data-dismiss="alert" aria-label="Close">
																			<span aria-hidden="true"><i className="la la-close"></i></span>
																		</button>
																	</div>
																</div>*/}
																		
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Change Your Password:</h3>
																	</div>
																</div>
																{/*
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Current Password</label>
																	<div className="col-lg-9 col-xl-6">
																		<input type="password" className="form-control" value="" placeholder="Current password"/>
																		<a href="www.smartch.com" className="kt-link kt-font-sm kt-font-bold kt-margin-t-5">Forgot password ?</a>
																	</div>
																</div>*/}
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">New Password</label>
																	<div className="col-lg-9 col-xl-6">
																		
																		<Field
																		  type="password"
																		  value ={values.password}
																		   name="password"
																		  className={`form-control ${
																		    touched.password && errors.password ? "is-invalid" : ""
																		  }`}
																		/>
																		
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Verify Password</label>
																	<div className="col-lg-9 col-xl-6">
																		
																		<Field
																		  type="password"
																		  value ={values.verifyPassword}
																		  name="verifyPassword"
																		  className={`form-control ${
																		    touched.verifyPassword && errors.verifyPassword ? "is-invalid" : ""
																		  }`}
																		/>
																		
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"></div>
													<div className="kt-form__actions">
														<div className="row">
															<div className="col-xl-3"></div>
															<div className="col-lg-9 col-xl-6">
																<button
								                          disabled={this.state.isSubmitting}
								                         type="submit"
								                            className={`btn btn-label-brand btn-bold ${clsx(
								                              {
								                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
								                              }
								                            )}`}
								                          >
								                           Update
								                        </button>
																{/*<a href="www.smartch.com" className="btn btn-label-brand btn-bold">Save changes</a>
																<a href="www.smartch.com" className="btn btn-clean btn-bold">Cancel</a>*/}
															</div>
														</div>
													</div>
												
												 </form>
								                  )}
								                </Formik>
								                </div>
											</div>
											<div className={"tab-pane " + this.state.tab4} id="kt_user_edit_tab_4" role="tabpanel">
												<div className="kt-form kt-form--label-right">
													<div className="kt-form__body">
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Setup Email Notification:</h3>
																	</div>
																</div>
																<div className="form-group form-group-sm row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Email Notification</label>
																	<div className="col-lg-9 col-xl-6">
																		<span className="kt-switch">
																			<label>
																				<input type="checkbox" checked="checked" name="email_notification_1"/>
																				<span></span>
																			</label>
																		</span>
																	</div>
																</div>
																<div className="form-group form-group-last row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Send Copy To Personal Email</label>
																	<div className="col-lg-9 col-xl-6">
																		<span className="kt-switch">
																			<label>
																				<input type="checkbox" name="email_notification_2"/>
																				<span></span>
																			</label>
																		</span>
																	</div>
																</div>
															</div>
														</div>
														<div className="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg"></div>
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Activity Related Emails:</h3>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">When To Email</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-checkbox-list">
																			<label className="kt-checkbox">
																				<input type="checkbox"/> You have new notifications.
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox"/> You're sent a direct message
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox" checked="checked"/> Someone adds you as a connection
																				<span></span>
																			</label>
																		</div>
																	</div>
																</div>
																<div className="form-group form-group-last row">
																	<label className="col-xl-3 col-lg-3 col-form-label">When To Escalate Emails</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-checkbox-list">
																			<label className="kt-checkbox kt-checkbox--brand">
																				<input type="checkbox"/> Upon new order.
																				<span></span>
																			</label>
																			<label className="kt-checkbox kt-checkbox--brand">
																				<input type="checkbox"/> New membership approval
																				<span></span>
																			</label>
																			<label className="kt-checkbox kt-checkbox--brand">
																				<input type="checkbox" checked="checked"/> Member registration
																				<span></span>
																			</label>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="kt-separator kt-separator--border-dashed kt-separator--portlet-fit kt-separator--space-lg"></div>
														<div className="kt-section kt-section--first">
															<div className="kt-section__body">
																<div className="row">
																	<label className="col-xl-3"></label>
																	<div className="col-lg-9 col-xl-6">
																		<h3 className="kt-section__title kt-section__title-sm">Updates From Keenthemes:</h3>
																	</div>
																</div>
																<div className="form-group row">
																	<label className="col-xl-3 col-lg-3 col-form-label">Email You With</label>
																	<div className="col-lg-9 col-xl-6">
																		<div className="kt-checkbox-list">
																			<label className="kt-checkbox">
																				<input type="checkbox"/> News about Metronic product and feature updates
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox"/> Tips on getting more out of Keen
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox" checked="checked"/> Things you missed since you last logged into Keen
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox" checked="checked"/> News about Metronic on partner products and other services
																				<span></span>
																			</label>
																			<label className="kt-checkbox">
																				<input type="checkbox" checked="checked"/> Tips on Metronic business products
																				<span></span>
																			</label>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
								
					</div>
				</div>





      		</>
      	);
     }
}   

export default injectIntl(MyProfile);
